
import { WDFormButton } from './wd-form-button';

export class WDFormButtonmulti extends WDFormButton
{

	#values = [];

	get value() { return this.#values; };

	set value(data)
	{
		const isChanged = !Object.is(data, this.#values);
		this.#values = data;

		//setup our button text
		if (this.#values.length > 0)
		{
			//get our display separator
			const separator = (typeof (this.config.separator) != 'undefined') ? this.config.separator : ',';

			let lbls = [];
			data.forEach(obj =>
			{
				lbls.push(this.config.templates.label.interpolate(obj));
			});

			this.button.label = lbls.join(separtor);
		}
		else
		{
			this.button.label = 'Not Selected';
		}

		this.trigger('value:set');
		if (isChanged) this.trigger('change');
	};

};

customElements.define('wd-form-button-multi', WDFormButtonmulti);
